/**
 * ToteLoadingScreen — Full-screen loading state displayed while tote contents
 * are being fetched. Visually consistent with ClassificationProgressScreen
 * used in the product classification flow.
 */

import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import arrowLeftTokens from "@amzn/meridian-tokens/base/icon/arrow-left-large";
import { Button, Icon } from "@amzn/meridian";
import AiStarLoader from "./AiStarLoader";
import BarcodeIcon from "src/components/UI/BarcodeIcon";
import "./classification.scss";

interface ToteLoadingScreenProps {
  scannableId: string;
  onBack: () => void;
}

const ToteLoadingScreen: React.FC<ToteLoadingScreenProps> = ({ scannableId, onBack }) => {
  return (
    <Column className="app-gradient-bg home-content pwa-scrollable" spacingInset="500" spacing="400">
      {/* Header */}
      <Row alignmentVertical="center" spacingInset="300 none none" spacing="400">
        <Button type="icon" onClick={onBack}>
          <Icon color="success" tokens={arrowLeftTokens} />
        </Button>
        <Column spacing="200" spacingInset="400 none">
          <Text type="h400">Loading Tote…</Text>
          <Text type="b200" color="secondary">
            Fetching tote contents and item manifest
          </Text>
        </Column>
      </Row>

      {/* Tote info card */}
      <Row className="home-card" spacing="400" spacingInset="400" alignmentVertical="center">
        <BarcodeIcon />
        <Column spacing="100">
          <Text type="h100">Tote</Text>
          <Text type="b100" color="secondary">ID: {scannableId}</Text>
        </Column>
      </Row>

      {/* Loader */}
      <Row spacingInset="400 none none" alignmentVertical="center" spacing="300">
        <AiStarLoader size={40} />
        <Text type="b300" color="secondary">Retrieving items from tote</Text>
      </Row>
    </Column>
  );
};

export default ToteLoadingScreen;
